import { graphql } from "@opensea/graphql"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"
import { useCollectionOffersFragment } from "../../use-collection-offers.fragment"
import { OfferAggregateBiddersFragment } from "./OfferAggregateBidders.fragment"

export const OfferAggregateTableRowFragment = graphql(
  `
    fragment OfferAggregateTableRow on OfferAggregate {
      offerPrice {
        token {
          unit
          contractAddress
        }
        ...TokenPrice
      }
      totalValue {
        token {
          unit
        }
        ...TokenPrice
      }
      totalOffers
      bidders {
        quantity
      }
      ...OfferAggregateBidders
    }
  `,
  [TokenPriceFragment, OfferAggregateBiddersFragment],
)

export const OfferAggregateTableRow_collectionFragment = graphql(
  `
    fragment OfferAggregateTableRow_collection on Collection {
      ...useCollectionOffers
    }
  `,
  [useCollectionOffersFragment],
)
